import React, { Component } from 'react';
import classnames from 'classnames';

import './TimeSlotListItem.css';

class TimeSlotListItem extends Component {
  constructor(props) {
    super(props);
    this.startDateTime = this.props.timeSlot.startDateTime.clone();
    this.endDateTime = this.props.timeSlot.endDateTime.clone();
  }

  // use arrow notation to bind this
  handleClick = () => {
    this.props.onSelectTimeSlot(this.props.timeSlot);
  }

  render() {
    const { selectedTimeSlot } = this.props;
    const isSelected = selectedTimeSlot ?
      selectedTimeSlot.startDateTime.isSame(this.startDateTime) :
      false;

    return (
      <button
        className={classnames(
          'TimeSlotListItem btn btn-cursor p-3',
          { 'btn-primary': isSelected },
          { 'btn-secondary': !isSelected }
        )}
        type="button"
        onClick={this.handleClick}
      >
        {this.startDateTime.format('h:mmA')} - {this.endDateTime.format('h:mmA')}
      </button>
    );
  }
}

export default TimeSlotListItem;



// WEBPACK FOOTER //
// ./src/components/TimeSlotListItem/TimeSlotListItem.js